import { Avatar, Flex, Typography } from "antd";
import { getRandomAvatarColor } from "../../utils/ui.utils";

const initialsFor = (name: string) =>
  name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

type Props = {
  name: string;
  initials?: string;
  subtitle?: string | null;
  avatarSize?: number;
};

const ClinicianAvatarCell = ({ name, initials, subtitle, avatarSize = 32 }: Props) => (
  <Flex align="center" gap={12}>
    <Avatar
      size={avatarSize}
      style={{
        backgroundColor: getRandomAvatarColor(name),
        fontSize: Math.round(avatarSize * 0.4),
        fontWeight: 500,
      }}
    >
      {initials ?? initialsFor(name)}
    </Avatar>
    <Flex vertical style={{ minWidth: 0 }}>
      <Typography.Text strong style={{ fontSize: 13 }}>
        {name}
      </Typography.Text>
      {subtitle ? <Typography.Text style={{ fontSize: 11, color: "#6b7280" }}>{subtitle}</Typography.Text> : null}
    </Flex>
  </Flex>
);

export default ClinicianAvatarCell;
